/**
 * @file 活动相关
 */
import { useUserStore } from '@/store/User';
import { pinia } from './index';
import { plus, gt, lt } from '@/utils/number';
import { activityApi, $common, affiliates } from '@/config/api.ts';
// import useVisitor from '@/hook/useVisitor';

const userStore = useUserStore(pinia);
// const { getVisitorId } = useVisitor();

interface UniversalPopList {
  activityEndTime:number
  buttonContent:string
  endTime:number
  h5_image:string
  id:number
  image:string
  popUpType:number
  startTime:number
  title:string
  url:string
  index:number
  remind?:boolean
}
export const useActivityStore = defineStore('activityStore', {
  state: () => ({
    startTime: <null | number>null,
    endTime: <null | number>null,
    timeDifference: <null | number>null,
    serverTime: <null | number>null,
    isFinished: <boolean>false,
    isVisible: <boolean>false,
    universalPop: false,
    droguePop: false,
    universalPopList: [
    ] as UniversalPopList[],
    drogueList: {} as UniversalPopList,
    // 专属活动数据
    exclusiveActivityRes: <any>{}
  }),
  getters: {
    // 未登录 并且 一天内没有过弹窗
    homeDialog() {
      return !userStore.isLogin && localStorage.getItem('activityVisible') !== new Date().toDateString();
    }
  },
  actions: {
    async getActivityTime() {
      const res: any = await activityApi.experience_card_info({ activityName: 'futures-activity' });
      if (res.success) {
        this.startTime = res.data.startTime;
        this.endTime = res.data.endTime;
        this.endTime = res.data.endTime;
        this.serverTime = res.data.serverTime;
        this.timeDifference = res.data.serverTime - new Date().getTime();
        this.isFinished = res.data.isFinished;
        this.isVisible = res.data.isVisible;
      }
    },
    async getPopUpList(param: any) {
      // const visitorData: any = await getVisitorId();
      // console.log(visitorData);
      this.droguePop = false;
      this.universalPop = false;
      const res: any = await $common.popUpList(param);
      if (res.success) {
        this.universalPopList = res.data?.filter((e:any) => e.popUpType == 0).map((e:any, i:number) => {
          e.index = i;
          e.remind = false;
          return e;
        });
        this.drogueList = res.data.find((e:any) => e.popUpType == 1);
        if (this.drogueList?.image) {
          this.droguePop = true;
        }
        if (this.universalPopList.length > 0) {
          this.universalPop = true;
        }
      }
    },
    isActivityTime(time:number) {
      const nowTime = plus(time, this.timeDifference);
      return lt(this.startTime, nowTime) && gt(this.endTime, nowTime);
    },
    async getExclusiveActivity(invite_code: string, activityId: any = '') {
      const res: any = await affiliates.getExclusiveActivity({
        inviteCode: invite_code,
        activityType: 1,
        activityId: activityId || ''
      });

      // 为什么这里要同事判断success和code ?
      if (res.success && res.code === 200) {
        this.exclusiveActivityRes = res;
      }

      return res;
    }
  }
});
